import React from "react";
import { css } from "@emotion/react";
import {
  color,
  Font,
  Icon,
  TextLink,
} from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  name: string;
  value: string;
};

export const SiteUrlLabel = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          {props.name}
        </Font>
      </div>
      <div css={inputWrapper}>
        {props.value ? (
          <TextLink target="_blank" href={props.value}>
            <span style={{ display: "flex", alignItems: "center" }}>
              <span css={{ marginRight: 8 }}>{props.value}</span>
              <Icon name="openInNew" size="sm" css={{ cursor: "pointer" }} />
            </span>
          </TextLink>
        ) : (
          <Font>{"----------"}</Font>
        )}
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  color: color.gray600,
});

const inputWrapper = css({
  width: "100%",
});
